<template>
    <div>
        <div class="grid form-element-wrapper mt-4">
            <strong>Eigene Farbe auswählen</strong>
        </div>
        <div class="grid grid-cols-2 form-element-wrapper">
            <div class="mt-1 form-element">
                <div class="label">Amplitude</div>
                <ColorPicker name="color"
                    :value="color"
                    @change="applyColor(idx, $event, triggerChange)"
                ></ColorPicker>
            </div>

            <div class="mt-1 form-element">
                <div class="label">Hintergrund</div>
                <ColorPicker name="backgroundColor"
                    :value="backgroundColor"
                    @change="applyBackgroundColor(idx, $event, triggerChange)"
                ></ColorPicker>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import { mapFields } from 'vuex-map-fields';
import Pipeline from "~/scripts/Pipeline/Pipeline.js";
import ColorPicker from "../../../Components/ColorPicker.vue";

export default {
    props: {
        colorPreset: String,
        backgroundColorPreset: String,
        idx: Number
    },

    components: {
        ColorPicker
    },

    data() {
        return {
            triggerChange: true,
            color: this.colorPreset,
            backgroundColor: this.backgroundColorPreset,
        }
    },

    computed: {
        ...mapFields({
            'border': 'stageConfiguration.border',
            'borderColor': 'stageConfiguration.borderColor'
        })
    },

    methods: {
        applyColor(idx, value, triggerChange) {
            this.setColor(value);
            Pipeline.updateSingleWaveColor(idx, value, triggerChange);
        },

        applyBackgroundColor(idx, value, triggerChange) {
            this.setBackgroundColor(value);

            if (triggerChange) {
                Pipeline.setWaveValue(idx, 'backgroundColor', value);
                Pipeline.updateWaveBackgroundColor(idx);
            }
        },

        setColor(value) {
            this.color = value;
        },

        setBackgroundColor(value) {
            this.backgroundColor = value;
        }
    }
}
</script>
